module.exports = __webpack_public_path__ + "img/banner-certificate.c3ab3ed6.jpg";